import { render, staticRenderFns } from "./pageOption.vue?vue&type=template&id=5f68507e"
import script from "./pageOption.vue?vue&type=script&lang=js"
export * from "./pageOption.vue?vue&type=script&lang=js"
import style0 from "./pageOption.vue?vue&type=style&index=0&id=5f68507e&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports